import React from "react";

const Error = ({ errorName }) => {
  return (
    <>
      {errorName && (
        <span className="bg-red-400 text-white py-1 px-2 rounded-md text-xs absolute">
          {errorName.message}
        </span>
      )}
    </>
  );
};

export default Error;
